// 新規登記ページ（業務担当者）。
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ContractForm,
  emptyFormValues,
  type FormAction,
} from "./ContractForm";
import { api, ApiError } from "../../lib/api";
import { useAuth } from "../../auth";
import { t } from "../../i18n/zh-TW";
import type { ContractFormValues } from "../../lib/types";

export function NewContractPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user && user.role !== "staff") {
    return (
      <div className="rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800">
        僅業務承辦人可建立合約登記。
      </div>
    );
  }

  async function onAction(values: ContractFormValues, action: FormAction) {
    setBusy(true);
    setError(null);
    try {
      await api.createContract(values, action === "submit" ? "submit" : "draft");
      navigate("/");
    } catch (e) {
      setError(e instanceof ApiError ? e.message : t.errors.saveFailed);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-5 text-xl font-semibold text-slate-800">{t.form.newTitle}</h1>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <ContractForm
          mode="create"
          initialValues={emptyFormValues()}
          submitting={busy}
          serverError={error}
          onAction={onAction}
        />
      </div>
    </div>
  );
}
